// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    margin-top: 20px;
    font-family: "Rigidica Text Regular", sans-serif;
}

.checkout-container {
    display: flex;
    justify-content: space-between;
    gap: 40px;
    flex-wrap: wrap;
}

.checkout-page h1 {
    font-family: "Rigidica Text Bold", sans-serif;
    color: #333;
    font-size: 32px;
    margin-bottom: 30px;
}

.checkout-page h2 {
    font-family: "Rigidica Text Regular", sans-serif;
    margin-top: 30px;
    margin-bottom: 20px;
    color: #333;
    font-size: 22px;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
}

.payment-method {
    font-family: "Rigidica Text Regular", sans-serif;
    color: #333;
    font-size: 16px;
    margin-bottom: 15px;
}

.checkout-form {
    flex: 1 1;
    min-width: 300px;
    background-color: #f9f9f9;
    border-radius: 8px;
    padding: 25px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    order: 1;
}

.checkout-cart {
    flex: 1 1;
    min-width: 300px;
    max-width: 500px;
    order: 2;
}

.checkout-form form {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.checkout-form input,
.checkout-input {
    padding: 14px;
    border: 1px solid #ddd;
    border-radius: 6px;
    outline: none;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 15px;
    width: 100%;
    background-color: white;
}

.checkout-form input:focus,
.checkout-input:focus {
    border-color: #ddd;
    outline: none;
    box-shadow: none;
}

.checkout-form-btn {
    padding: 10px;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    width: 100%;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 16px;
    margin-top: 25px;
}

.checkout-form-btn:hover {
    background-color: #444;
}

.back-btn {
    padding: 8px 16px;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 14px;
    margin-top: 10px;
}

.back-btn:hover {
    background-color: #444;
}

.payment-button {
    padding: 10px;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 16px;
    margin-top: 10px;
}

.payment-button:hover {
    background-color: #444;
}

.checkout-form-btn:disabled {
    background-color: #aaa;
    cursor: not-allowed;
}

.error-message {
    color: #dc3545;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 14px;
    margin-bottom: 15px;
    padding: 12px;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 6px;
}

.combined-card-field {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px 12px;
    background-color: white;
}

.combined-card-field:focus-within {
    border-color: #ddd;
    outline: none;
    box-shadow: none;
}

.combined-card-field input {
    border: none;
    padding: 6px;
    outline: none;
    font-size: 15px;
}

.card-number-input {
    flex: 3 1;
    min-width: 0;
}

.expire-date-input,
.cvc-input {
    flex: 1 1;
    min-width: 0;
    text-align: center;
}

.card-separator {
    color: #777;
    margin: 0 5px;
    font-weight: normal;
}

.empty-cart-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin-top: 30px;
    text-align: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.empty-cart-message h2 {
    font-family: "Rigidica Text Bold", sans-serif;
    color: #333;
    margin-bottom: 20px;
    border-bottom: none;
}

.empty-cart-message p {
    font-family: "Rigidica Text Regular", sans-serif;
    color: #555;
    margin-bottom: 30px;
    font-size: 16px;
}

.continue-shopping-btn {
    padding: 14px 28px;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 6px;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-weight: 500;
}

.continue-shopping-btn:hover {
    background-color: #444;
}

.loading-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 100;
}

.loading-box {
    text-align: center;
    font-size: 24px;
    color: #333;
    font-family: "Rigidica Text Light", sans-serif;
    padding: 30px 50px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.loading-text {
    font-size: 22px;
}

.or-divider {
    text-align: center;
    font-size: 16px;
    color: #666;
    font-family: "Rigidica Text Regular", sans-serif;
    position: relative;
    margin: 20px 0;
}

.or-divider::before,
.or-divider::after {
    content: "";
    display: block;
    width: 40%;
    height: 1px;
    background: #ddd;
    position: absolute;
    top: 50%;
}

.or-divider::before {
    left: 0;
}

.or-divider::after {
    right: 0;
}

.checkout-option-btn {
    padding: 14px 24px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 6px;
    margin: 10px 0;
    background-color: #333;
    color: white;
    border: none;
    transition: background-color 0.3s ease;
    font-family: "Rigidica Text Regular", sans-serif;
    width: 100%;
    font-weight: 500;
}

.checkout-option-btn:hover {
    background-color: #444;
}

.checkout-type-selection {
    margin-bottom: 30px;
}

.checkout-options {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.shipping-summary {
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 6px;
    margin-bottom: 25px;
    border-left: 4px solid #333;
}

.shipping-summary h3 {
    font-family: "Rigidica Text Bold", sans-serif;
    color: #333;
    margin-bottom: 15px;
    font-size: 18px;
}

.shipping-summary p {
    font-family: "Rigidica Text Regular", sans-serif;
    margin: 8px 0;
    color: #444;
    font-size: 15px;
}

.edit-address-btn {
    margin-top: 15px;
    background: none;
    border: 1px solid #333;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 14px;
    color: #333;
    transition: all 0.3s ease;
}

.edit-address-btn:hover {
    background-color: #eee;
}

.payment-container {
    margin-top: 25px;
    padding: 20px;
    background-color: white;
    border-radius: 6px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.guest-checkout-note {
    margin-top: 20px;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 14px;
    color: #555;
    padding: 12px;
    background-color: #f0f0f0;
    border-radius: 6px;
    border-left: 4px solid #666;
}

/* Improved cart styling */
.checkout-cart {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

/* Order summary section */
.cart-summary {
    border-top: 1px solid #ddd;
    margin-top: 20px;
    padding-top: 15px;
}

.cart-summary-item {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 15px;
    color: #444;
}

.cart-total {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 2px solid #ddd;
    font-weight: bold;
    font-size: 18px;
    color: #333;
}

/* Product items in cart */
.cart-item {
    display: flex;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
}

.cart-item-info {
    flex: 1 1;
}

.cart-item-title {
    font-weight: 500;
    margin-bottom: 5px;
    color: #333;
}

.cart-item-price {
    font-weight: 500;
    color: #333;
}

.cart-item-quantity {
    display: flex;
    align-items: center;
    gap: 10px;
}

.quantity-btn {
    background-color: #eee;
    border: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 18px;
    color: #333;
    transition: background-color 0.2s ease;
}

.quantity-btn:hover {
    background-color: #ddd;
}

.quantity-display {
    font-size: 16px;
    font-weight: 500;
}

.remove-btn {
    background-color: transparent;
    color: #999;
    border: none;
    padding: 5px 10px;
    font-size: 14px;
    cursor: pointer;
    transition: color 0.2s ease;
}

.remove-btn:hover {
    color: #dc3545;
}

/* CSS Media Queries */

@media (max-width: 2560px) {
    .checkout-container {
        justify-content: space-between;
    }
}

@media (max-width: 1920px) {
    .checkout-page {
        padding: 15px;
    }
}

@media (max-width: 1536px) {
    .checkout-container {
        gap: 30px;
    }
}

@media (max-width: 1440px) {
    .checkout-cart {
        max-width: 450px;
    }
}

@media (max-width: 1280px) {
    .checkout-cart {
        max-width: 400px;
    }
}

@media (max-width: 1024px) {
    .checkout-container {
        gap: 20px;
    }

    .checkout-cart {
        max-width: 350px;
    }

    .checkout-page h1 {
        font-size: 28px;
    }
}

@media (max-width: 768px) {
    .checkout-container {
        flex-direction: column-reverse;
    }

    .checkout-form {
        order: 2;
        min-width: 100%;
    }

    .checkout-cart {
        order: 1;
        max-width: 100%;
        margin-bottom: 20px;
    }

    .checkout-page h1 {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .checkout-page h2 {
        font-size: 20px;
    }
}

@media (max-width: 600px) {
    .checkout-page {
        padding: 10px;
    }

    .checkout-form {
        padding: 15px;
    }

    .checkout-cart {
        padding: 15px;
    }

    .empty-cart-container {
        padding: 30px;
    }

    .checkout-form input,
    .checkout-input {
        padding: 12px;
    }
}

@media (max-width: 599px) {
    .checkout-page h1 {
        font-size: 22px;
        margin-bottom: 15px;
    }

    .checkout-form-btn,
    .checkout-option-btn,
    .continue-shopping-btn {
        padding: 12px 20px;
        font-size: 14px;
    }

    .shipping-summary {
        padding: 15px;
    }

    .payment-container {
        padding: 15px;
    }

    .guest-checkout-note {
        font-size: 12px;
        padding: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/CheckoutPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;IAChD,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,0CAA0C;IAC1C,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gDAAgD;IAChD,eAAe;IACf,WAAW;IACX,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,sCAAsC;IACtC,gDAAgD;IAChD,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,gDAAgD;IAChD,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,gDAAgD;IAChD,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gDAAgD;IAChD,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;;IAEI,SAAO;IACP,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,8CAA8C;IAC9C,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gDAAgD;IAChD,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,sCAAsC;IACtC,gDAAgD;IAChD,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gDAAgD;IAChD,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gDAAgD;IAChD,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,gDAAgD;IAChD,eAAe;IACf,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,0BAA0B;AAC1B;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB;;AAEtB;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;;;QAGI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;AACJ","sourcesContent":[".checkout-page {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    margin-top: 20px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.checkout-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 40px;\n    flex-wrap: wrap;\n}\n\n.checkout-page h1 {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    color: #333;\n    font-size: 32px;\n    margin-bottom: 30px;\n}\n\n.checkout-page h2 {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    margin-top: 30px;\n    margin-bottom: 20px;\n    color: #333;\n    font-size: 22px;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 10px;\n}\n\n.payment-method {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #333;\n    font-size: 16px;\n    margin-bottom: 15px;\n}\n\n.checkout-form {\n    flex: 1;\n    min-width: 300px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    padding: 25px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n    order: 1;\n}\n\n.checkout-cart {\n    flex: 1;\n    min-width: 300px;\n    max-width: 500px;\n    order: 2;\n}\n\n.checkout-form form {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.checkout-form input,\n.checkout-input {\n    padding: 14px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    outline: none;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 15px;\n    width: 100%;\n    background-color: white;\n}\n\n.checkout-form input:focus,\n.checkout-input:focus {\n    border-color: #ddd;\n    outline: none;\n    box-shadow: none;\n}\n\n.checkout-form-btn {\n    padding: 10px;\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    width: 100%;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 16px;\n    margin-top: 25px;\n}\n\n.checkout-form-btn:hover {\n    background-color: #444;\n}\n\n.back-btn {\n    padding: 8px 16px;\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 14px;\n    margin-top: 10px;\n}\n\n.back-btn:hover {\n    background-color: #444;\n}\n\n.payment-button {\n    padding: 10px;\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 16px;\n    margin-top: 10px;\n}\n\n.payment-button:hover {\n    background-color: #444;\n}\n\n.checkout-form-btn:disabled {\n    background-color: #aaa;\n    cursor: not-allowed;\n}\n\n.error-message {\n    color: #dc3545;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 14px;\n    margin-bottom: 15px;\n    padding: 12px;\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    border-radius: 6px;\n}\n\n.combined-card-field {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    background-color: white;\n}\n\n.combined-card-field:focus-within {\n    border-color: #ddd;\n    outline: none;\n    box-shadow: none;\n}\n\n.combined-card-field input {\n    border: none;\n    padding: 6px;\n    outline: none;\n    font-size: 15px;\n}\n\n.card-number-input {\n    flex: 3;\n    min-width: 0;\n}\n\n.expire-date-input,\n.cvc-input {\n    flex: 1;\n    min-width: 0;\n    text-align: center;\n}\n\n.card-separator {\n    color: #777;\n    margin: 0 5px;\n    font-weight: normal;\n}\n\n.empty-cart-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 50px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    margin-top: 30px;\n    text-align: center;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.empty-cart-message h2 {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    color: #333;\n    margin-bottom: 20px;\n    border-bottom: none;\n}\n\n.empty-cart-message p {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #555;\n    margin-bottom: 30px;\n    font-size: 16px;\n}\n\n.continue-shopping-btn {\n    padding: 14px 28px;\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    font-weight: 500;\n}\n\n.continue-shopping-btn:hover {\n    background-color: #444;\n}\n\n.loading-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.9);\n    z-index: 100;\n}\n\n.loading-box {\n    text-align: center;\n    font-size: 24px;\n    color: #333;\n    font-family: \"Rigidica Text Light\", sans-serif;\n    padding: 30px 50px;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n}\n\n.loading-text {\n    font-size: 22px;\n}\n\n.or-divider {\n    text-align: center;\n    font-size: 16px;\n    color: #666;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    position: relative;\n    margin: 20px 0;\n}\n\n.or-divider::before,\n.or-divider::after {\n    content: \"\";\n    display: block;\n    width: 40%;\n    height: 1px;\n    background: #ddd;\n    position: absolute;\n    top: 50%;\n}\n\n.or-divider::before {\n    left: 0;\n}\n\n.or-divider::after {\n    right: 0;\n}\n\n.checkout-option-btn {\n    padding: 14px 24px;\n    font-size: 16px;\n    cursor: pointer;\n    border-radius: 6px;\n    margin: 10px 0;\n    background-color: #333;\n    color: white;\n    border: none;\n    transition: background-color 0.3s ease;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    width: 100%;\n    font-weight: 500;\n}\n\n.checkout-option-btn:hover {\n    background-color: #444;\n}\n\n.checkout-type-selection {\n    margin-bottom: 30px;\n}\n\n.checkout-options {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.shipping-summary {\n    background-color: #f5f5f5;\n    padding: 20px;\n    border-radius: 6px;\n    margin-bottom: 25px;\n    border-left: 4px solid #333;\n}\n\n.shipping-summary h3 {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    color: #333;\n    margin-bottom: 15px;\n    font-size: 18px;\n}\n\n.shipping-summary p {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    margin: 8px 0;\n    color: #444;\n    font-size: 15px;\n}\n\n.edit-address-btn {\n    margin-top: 15px;\n    background: none;\n    border: 1px solid #333;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 14px;\n    color: #333;\n    transition: all 0.3s ease;\n}\n\n.edit-address-btn:hover {\n    background-color: #eee;\n}\n\n.payment-container {\n    margin-top: 25px;\n    padding: 20px;\n    background-color: white;\n    border-radius: 6px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.guest-checkout-note {\n    margin-top: 20px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 14px;\n    color: #555;\n    padding: 12px;\n    background-color: #f0f0f0;\n    border-radius: 6px;\n    border-left: 4px solid #666;\n}\n\n/* Improved cart styling */\n.checkout-cart {\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n/* Order summary section */\n.cart-summary {\n    border-top: 1px solid #ddd;\n    margin-top: 20px;\n    padding-top: 15px;\n}\n\n.cart-summary-item {\n    display: flex;\n    justify-content: space-between;\n    margin: 10px 0;\n    font-size: 15px;\n    color: #444;\n}\n\n.cart-total {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 2px solid #ddd;\n    font-weight: bold;\n    font-size: 18px;\n    color: #333;\n}\n\n/* Product items in cart */\n.cart-item {\n    display: flex;\n    margin-bottom: 15px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #eee;\n}\n\n.cart-item-info {\n    flex: 1;\n}\n\n.cart-item-title {\n    font-weight: 500;\n    margin-bottom: 5px;\n    color: #333;\n}\n\n.cart-item-price {\n    font-weight: 500;\n    color: #333;\n}\n\n.cart-item-quantity {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.quantity-btn {\n    background-color: #eee;\n    border: none;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 18px;\n    color: #333;\n    transition: background-color 0.2s ease;\n}\n\n.quantity-btn:hover {\n    background-color: #ddd;\n}\n\n.quantity-display {\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.remove-btn {\n    background-color: transparent;\n    color: #999;\n    border: none;\n    padding: 5px 10px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: color 0.2s ease;\n}\n\n.remove-btn:hover {\n    color: #dc3545;\n}\n\n/* CSS Media Queries */\n\n@media (max-width: 2560px) {\n    .checkout-container {\n        justify-content: space-between;\n    }\n}\n\n@media (max-width: 1920px) {\n    .checkout-page {\n        padding: 15px;\n    }\n}\n\n@media (max-width: 1536px) {\n    .checkout-container {\n        gap: 30px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .checkout-cart {\n        max-width: 450px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .checkout-cart {\n        max-width: 400px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .checkout-container {\n        gap: 20px;\n    }\n\n    .checkout-cart {\n        max-width: 350px;\n    }\n\n    .checkout-page h1 {\n        font-size: 28px;\n    }\n}\n\n@media (max-width: 768px) {\n    .checkout-container {\n        flex-direction: column-reverse;\n    }\n\n    .checkout-form {\n        order: 2;\n        min-width: 100%;\n    }\n\n    .checkout-cart {\n        order: 1;\n        max-width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .checkout-page h1 {\n        font-size: 24px;\n        margin-bottom: 20px;\n    }\n\n    .checkout-page h2 {\n        font-size: 20px;\n    }\n}\n\n@media (max-width: 600px) {\n    .checkout-page {\n        padding: 10px;\n    }\n\n    .checkout-form {\n        padding: 15px;\n    }\n\n    .checkout-cart {\n        padding: 15px;\n    }\n\n    .empty-cart-container {\n        padding: 30px;\n    }\n\n    .checkout-form input,\n    .checkout-input {\n        padding: 12px;\n    }\n}\n\n@media (max-width: 599px) {\n    .checkout-page h1 {\n        font-size: 22px;\n        margin-bottom: 15px;\n    }\n\n    .checkout-form-btn,\n    .checkout-option-btn,\n    .continue-shopping-btn {\n        padding: 12px 20px;\n        font-size: 14px;\n    }\n\n    .shipping-summary {\n        padding: 15px;\n    }\n\n    .payment-container {\n        padding: 15px;\n    }\n\n    .guest-checkout-note {\n        font-size: 12px;\n        padding: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
